var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BusinessCrud',{attrs:{"title":"合同配置","columns":_vm.columns,"search-fields":_vm.searchFields,"form-fields":_vm.formFields,"list-api":_vm.getContractTemplateList,"save-api":_vm.saveContractTemplate,"delete-api":_vm.deleteContractTemplate,"defaults":{ templateType: '订单合同', contractTitle: '商城订单合同', taxRate: 13, status: 1 },"modal-width":900}})
}
var staticRenderFns = []

export { render, staticRenderFns }